import styled, { css } from 'styled-components';

import { Button } from '@xing-com/button';
import { IllustrationPremiumSpotGroup } from '@xing-com/illustrations';
import {
  mediaConfinedOnly,
  mediaSmallOnly,
  mediaTiny,
  mediaWide,
} from '@xing-com/layout-tokens';
import {
  scale060,
  scale080,
  scale090,
  scale110,
  scale130,
  scale140,
  scale150,
  scale170,
} from '@xing-com/tokens';
import { Column, Grid, Row } from '@xing-com/xing-grid';

export const StyledGrid = styled(Grid)`
  margin: ${scale150} 0;

  @media ${mediaTiny} {
    margin: ${scale140} 0 ${scale170};
  }
`;

export const ContentRow = styled(Row)`
  display: flex;
  justify-content: space-between;

  @media ${mediaTiny} {
    flex-direction: column-reverse;
  }
`;

const headlineCss = css`
  margin-bottom: ${scale090};
  margin-top: 0;
  font-size: ${scale150};
  line-height: 1.2;

  @media ${mediaConfinedOnly} {
    margin-bottom: ${scale080};
    font-size: ${scale130};
  }

  @media ${mediaSmallOnly} {
    margin-bottom: ${scale080};
    font-size: ${scale130};
  }

  @media ${mediaTiny} {
    margin: ${scale080} 0 ${scale060};
    font-size: ${scale110};
    text-align: center;
  }
`;

export const StyledHeadline = styled.h1`
  ${headlineCss};
`;

export const StyledSecondaryHeadline = styled.h2`
  ${headlineCss};
`;

export const StyledButton = styled(Button)`
  @media ${mediaTiny} {
    width: 100%;
  }
`;

export const IllustrationColumn = styled(Column)`
  display: flex;
  justify-content: flex-end;

  @media ${mediaTiny} {
    justify-content: center;
    text-align: center;
  }
`;

export const StyledIllustrationPremiumSpotGroup = styled(
  IllustrationPremiumSpotGroup
)`
  height: 68px;
  width: 68px;

  @media ${mediaWide} {
    height: 92px;
    width: 92px;
  }
`;
